/**
 * Footer
 */

import {observeInView} from '../../../shared/utils/observer';

import SelectorEngine from '../../../shared/dom/selector-engine';
import Manipulator    from '../../../shared/dom/manipulator';
import EventHandler from "../../../shared/dom/event-handler";

// -------
// Privat
// -------

let footerContainer = null;

// -------
// Public
// -------

const footer = () => {
	footerContainer = footerContainer || SelectorEngine.findOne('#page-footer');

	if (footerContainer) {
		const footerMain = SelectorEngine.findOne('.page-footer-bar.-main', footerContainer);
		const footerSupported = SelectorEngine.findOne('.page-footer-bar.-supported', footerContainer);

		//
		// Überwachung wann der Footer im ´Viewport´ erscheint.
		//

		if (footerMain) {
			// Observer initialisieren.
			observeInView(footerMain, {
				// onEnterViewport: (target, event) => {
				onEnterViewport: () => {
					Manipulator.addClass(document.documentElement, 'page-footer-main-in-view');
				},
				// onLeaveViewport: (target, event) => {
				onLeaveViewport: () => {
					Manipulator.removeClass(document.documentElement, 'page-footer-main-in-view');
				},
				observer: {
					threshold: 0
				}
			});
		}

		if (footerSupported) {
			// Observer initialisieren.
			observeInView(footerSupported, {
				onEnterViewport: () => {
					Manipulator.addClass(document.documentElement, 'page-footer-supported-in-view');
				},
				onLeaveViewport: () => {
					Manipulator.removeClass(document.documentElement, 'page-footer-supported-in-view');
				},
				observer: {
					threshold: 0
				}
			});
		}
	}

	return footerContainer;
};

// Export
export default footer;
